import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const OrderDetailsFullDisplay = () => {
  const { orderID } = useParams(); // Get the order ID from the URL

  return (
    <Box sx={{ padding: 3 }}>
      <Typography
        variant="h4"
        sx={{ marginBottom: 2 }}
      >
        Order Details for Order ID: {orderID}
      </Typography>
      {/* Add more detailed order information here */}
    </Box>
  );
};

export default OrderDetailsFullDisplay;
